import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_bell" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "dot"
}
const _hoisted_4 = { class: "notificationContent" }
const _hoisted_5 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  class: "title flex",
  style: {"gap":"10px"}
}
const _hoisted_8 = {
  key: 0,
  class: "redDot"
}
const _hoisted_9 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_ctx.$store.getters['user/isLoggedIn'] === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: "#",
          class: "bell",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModalHeader && _ctx.openModalHeader(...args)))
        }, [
          _hoisted_2,
          (_ctx.notificationsCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_OverlayPanel, {
          ref: "navRef",
          appendTo: "body",
          showCloseIcon: false,
          id: "overlay_panel",
          style: {"width":"290px"},
          class: "topOverlayNav"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InfinityScroll, {
              onLoadNextPage: _ctx.loadNotifications,
              data: _ctx.notifications,
              class: "browser-infinity-scroll userAccordion",
              "dont-use-mobile-handler": true,
              loading: _ctx.isLoading
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t("notification.title")), 1),
                  (_ctx.notifications.data?.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("alerts.no_notifications")), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications.data, (notification, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.pushRoute(notification))
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h3", null, [
                            _createTextVNode(_toDisplayString(notification.details.title ||
                    _ctx.getTitle(notification.details.feed_type)) + " ", 1),
                            (notification.seen === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$moment
                      .utc(notification.created_at)
                      .local()
                      .format("DD.MM.YYYY HH:mm")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(notification.details.text ||
                  _ctx.getText(notification.details.feed_type)), 1)
                      ], 8, _hoisted_6))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onLoadNextPage", "data", "loading"])
          ]),
          _: 1
        }, 512)
      ]))
    : _createCommentVNode("", true)
}